<template>
<i class="i" :style="styles" :title="title" :aria-hidden="ariaHidden" v-html="iconString"/>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface OIconInnerProps {
	// Wielkość ikony (w rem)
	size?: string | number;
	// Nadpisanie wysokości (w rem)
	height?: string | number;
	// Styl wyświetlania
	display?: string;
	// Tytuł elementu
	title?: string;
	// String z svg ikony
	iconString?: string;
	// Czy ikona powinna być ukryta dla czytników ekranu
	ariaHidden?: boolean;
}

const props = withDefaults(defineProps<OIconInnerProps>(), {
	display: 'inline-block',
	ariaHidden: false,
});

// Style dla standardowych ikon
const styles = computed(() => ({
	display: props.display,
	width: `${props.size || 1.25}rem`,
	height: `${props.height || props.size || 1.25}rem`,
	fill: 'currentColor',
}));
</script>
